import Component from './help-create';

export default Component;
